import React, { useState } from 'react'
import { Share2 } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { toast } from 'sonner'

interface ShareProps {
  url?: string;
  title?: string;
  className?: string;
}

const Share: React.FC<ShareProps> = ({ 
  url, 
  title = "Share this report",
  className = ""
}) => {
  const [isCopied, setIsCopied] = useState(false)
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  const handleCopyLink = async () => {
    try {
      const currentUrl = url || window.location.href
      await navigator.clipboard.writeText(currentUrl)
      setIsCopied(true)
      toast.success('Link copied to clipboard')
      
      // Auto-hide popover after 2 seconds
      setTimeout(() => {
        setIsPopoverOpen(false)
        setIsCopied(false)
      }, 2000)
    } catch (err) {
      toast.error('Failed to copy link')
      console.error('Failed to copy:', err)
    }
  }

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger asChild>
        <div className={`flex flex-row items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity ${className}`}>
          <Share2 className="w-4 h-4" />
          <span
            className="text-[16px] font-normal leading-6 tracking-[0.08px] font-['DM_Sans']"
            style={{ color: "var(--Button, #001630)" }}
          >
            Share
          </span>
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="end">
        <div className="p-4">
          <div className="text-sm font-medium text-gray-700 mb-2">{title}</div>
          <div className="flex mb-4">
            <input
              type="text"
              value={url || window.location.href}
              readOnly
              className="flex-1 p-2 text-xs border border-gray-300 rounded-l-md bg-gray-50"
            />
            <button
              onClick={handleCopyLink}
              className="px-3 py-2 text-xs font-medium text-white bg-button rounded-r-md hover:bg-[#062549]"
            >
              {isCopied ? "Copied!" : "Copy"}
            </button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default Share 